<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Perfect-Center"><br/></p>
<p class="Perfect-Center">“How lucky I am to have something that makes saying goodbye so hard.” A.A. Milne</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quote1.vue?192ff39c